import { NewrelicEvent, NewrelicEventTypes } from "@enums/newrelic-events";
import { recordCustomEvent } from "@utils/client/newrelic";

export const WebViewActions = {
  CLOSE_WEBVIEW: "close_webview",
  LOGIN: "login",
  OPEN_WEBVIEW: "open_webview",
  UPDATE_APP_BAR: "update_appbar",
  NATIVE_SHARE: "native_share",
  OPEN_CAMERA: "open_native_camera",
  OPEN_SETTINGS_PAGE: "open_settings_page",
  CHECK_PUSH_NOTIFICATION_PERMISSION: "check_notification_enabled",
};

interface IWebviewParams {
  url?: string;
  action: string;
}

interface IGenericWebviewParams {
  action: string;
  action_value?: Record<string, any>;
}

// Function for executing callback using js-interface when the page is running withing android/iOS App
export const callWebviewHandler = async ({ url, action }: IWebviewParams) => {
  const webViewData = url ? { action: action, action_value: { url: url } } : { action: action };
  const stringWebViewData = JSON.stringify(webViewData);
  //   @ts-ignore
  if (window?.flutter_inappwebview?.callHandler) {
    //   @ts-ignore
    return window.flutter_inappwebview.callHandler("WebViewConnect", stringWebViewData);
  }
};

export const webviewOpenHandler = (redirectUrl: string) => {
  const data = {
    action: "open_browser_tab",
    action_value: {
      redirect_url: redirectUrl,
    },
  };
  //@ts-ignore
  if (window?.flutter_inappwebview?.callHandler) {
    //@ts-ignore
    window?.flutter_inappwebview?.callHandler("WebViewConnect", JSON.stringify(data));
  } else {
    console.error("Flutter InAppWebView is not available");
  }
};

export const webviewCloseHandler = async () => {
  const data = {
    action: "close_browser_tab",
  };
  //@ts-ignore
  if (window?.flutter_inappwebview?.callHandler) {
    recordCustomEvent(NewrelicEvent.GOOGLE_CONSENT, {
      type: NewrelicEventTypes[NewrelicEvent.GOOGLE_CONSENT]
        .CLOSE_SAFARICHROME_TAB_TRIGERRED,
      status: "granted",
      message: "sending event to close safari chrome tab",
    });
    //@ts-ignore
    await window?.flutter_inappwebview?.callHandler(
      "WebViewConnect",
      JSON.stringify(data),
    );
  } else {
    console.error("Flutter InAppWebView is not available");
  }
};

interface GoogleSdkOpenHandlerProps {
  serverClientId: string;
  clientId: string;
  scopes: string[];
  isRetry?: boolean;
}

export const googleSdkOpenHandler = ({ serverClientId, clientId, scopes, isRetry }: GoogleSdkOpenHandlerProps) => {
  const gmailLinkRequest = {
    server_client_id: serverClientId,
    client_id: clientId,
    force_account_picker: !isRetry,
    force_revoke_access: !isRetry,
    scopes,
  };
  const data = {
    action: "get_gmail_access",
    action_value: {
      // Keep both payload shapes while the app bridge rolls forward.
      ...gmailLinkRequest,
      gmail_link_request: gmailLinkRequest,
    },
  };

  //   @ts-ignore
  if (window?.flutter_inappwebview?.callHandler) {
    //   @ts-ignore
    return window.flutter_inappwebview.callHandler("WebViewConnect", JSON.stringify(data));
  }
}

export const genericWebviewHandler = async ({ action, action_value }: IGenericWebviewParams) => {
  const stringWebViewData = JSON.stringify({
    action: action,
    action_value: action_value ? action_value : {},
  });
  //   @ts-ignore
  if (window?.flutter_inappwebview?.callHandler) {
    //   @ts-ignore
    return window.flutter_inappwebview.callHandler("WebViewConnect", stringWebViewData);
  }
}
